import { mergeStyleSets, Separator, Theme } from '@fluentui/react';
import React from 'react'
import '../styles/NoApps.css'
import { Login } from '@microsoft/mgt-react';
import { useTranslation } from 'react-i18next';

type NoAppsProps = {
    theme?: Theme,
    isDarkTheme?: boolean,
};

const NoApps: React.FC<NoAppsProps> = ({ theme, isDarkTheme }) => {
    const { t } = useTranslation();

    const cardContainer = mergeStyleSets({
        backgroundColor: theme?.palette.neutralLighter,
        borderTop: '2px solid #FD6262',
        borderRadius: '5px',
        width: '100%',
    });

    return (
        <div id='noappscontainer'>
            <div aria-roledescription="Welcome card" style={cardContainer} key="welcomecard" title={t('welcome')}>
                <div style={{ display: 'flex', justifyContent: 'center' }} >
                    <h3>{t('welcome')}</h3>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                    <label>{t('welcomeDescription')}</label>
                    <label id="message" style={{ marginBottom: 5 }}>{t('signInPrompt')}</label>
                    <Login className={isDarkTheme ? "mgt-dark" : "mgt-light"} />
                </div>
            </div>
        </div>
    )
}

export default NoApps;